// @flow

import * as React from 'react';
import {useEffect, useRef} from 'react';
import ContentTabs, {ContentTab} from 'sail/ContentTabs';
import Badge from 'sail/Badge';
import {useArticle, usePrefs, useLocation} from 'docs/data';
import {useActivePage} from 'docs/hooks';
import './PageSelector.scss';
import {useContentAnimation} from 'docs/shell/content/ContentAnimationProvider';

export const PageSelector = () => {
  const {article} = useArticle();
  const {setPrefs} = usePrefs();
  const activePage = useActivePage();
  const {replaceLocation} = useLocation();
  const ref = useRef();
  const {setAnimationDirection} = useContentAnimation();

  useEffect(() => {
    const index = article.pages.indexOf(activePage);
    if (ref.current) {
      ref.current.setActiveTab(index === -1 ? 0 : index);
    }
  }, [ref, activePage, article.pages]);

  const activeIndex = article.pages.indexOf(activePage);

  const tabs = article.pages.map((page, index, array) => (
    <ContentTab
      key={index}
      posInSet={index + 1}
      setSize={array.length}
      id={`tab-${page.title}`}
      contentID={`content-${page.title}`}
      active={page === activePage}
      onClick={() => {
        setPrefs(page.prefs);
        replaceLocation({query: page.prefs});
        setAnimationDirection(activeIndex, index);
      }}
      className="PageSelector-tab"
    >
      {page.title}
      {page.badge && <Badge {...page.badge} style={{verticalAlign: 'top'}} />}
    </ContentTab>
  ));

  return (
    <ContentTabs ref={ref} size="medium">
      {tabs}
    </ContentTabs>
  );
};
